export default {
    NA: 999,
    Billing: 1,
    HoldCreditCardLimit: 2,
    BillingOnHold: 3,
    RegisterAndCreateToken: 4
}